import convertReducer from './';

export default convertReducer;
